exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* #app{\n     background-image: url(./assets/img/mapg.png);\n background-size: 100%;\n} */\n    /* @import \"./assets/css/main.css\"; */\n    /* @import \"./assets/css/color-dark.css\";      */\n    /*深色主题*/\n    /*@import \"./assets/css/theme-green/color-green.css\";   浅绿色主题*/\n", ""]);

// exports
